export const icons = {
  Bold: 'lucide:bold',
  LoaderCircle: 'lucide:loader-circle',
  Italic: 'lucide:italic',
  Underline: 'lucide:underline',
  Quote: 'lucide:quote',
  TextQuote: 'lucide:text-quote',
  Strikethrough: 'lucide:strikethrough',
  Minus: 'lucide:minus',
  Eraser: 'lucide:eraser',
  PaintRoller: 'lucide:paint-roller',
  Redo2: 'lucide:redo-2',
  Undo2: 'lucide:undo-2',
  AlignCenter: 'radix-icons:text-align-center',
  AlignJustify: 'radix-icons:text-align-justify',
  AlignLeft: 'radix-icons:text-align-left',
  AlignRight: 'radix-icons:text-align-right',
  ChevronUp: 'lucide:chevron-up',
  ChevronDown: 'lucide:chevron-down',
  Subscript: 'lucide:subscript',
  Superscript: 'lucide:superscript',
  Code: 'lucide:code',
  Code2: 'lucide:code-2',
  Type: 'lucide:type',
  IndentIncrease: 'lucide:indent-increase',
  IndentDecrease: 'lucide:indent-decrease',
  List: 'lucide:list',
  ListOrdered: 'lucide:list-ordered',
  ListTodo: 'lucide:list-todo',
  Link: 'lucide:link',
  ImageUp: 'lucide:image-up',
  Video: 'lucide:video',
  Maximize: 'lucide:maximize',
  Minimize: 'lucide:minimize',
  Table: 'lucide:table',
  Sparkles: 'lucide:sparkles',
  Magic: 'mdi:magic',
  Pencil: 'lucide:pencil',
  Unlink: 'lucide:unlink',
  BetweenHorizonalEnd: 'lucide:between-horizontal-end',
  BetweenHorizonalStart: 'lucide:between-horizontal-start',
  ColumnDelete: 'hugeicons:column-delete',
  BetweenVerticalStart: 'lucide:between-vertical-start',
  BetweenVerticalEnd: 'lucide:between-vertical-end',
  RowDelete: 'hugeicons:row-delete',
  TableCellsMerge: 'lucide:table-cells-merge',
  TableCellsSplit: 'lucide:table-cells-split',
  Trash2: 'lucide:trash-2',
  Trash: 'lucide:trash',
  Replace: 'lucide:replace',
  ChevronsUpDown: 'lucide:chevrons-up-down',
  LineHeight: 'mdi:format-line-height',
  Word: 'mdi:file-word-outline',
  Paragraph: 'ci:text',
  Heading1: 'lucide:heading-1',
  Heading2: 'lucide:heading-2',
  Heading3: 'lucide:heading-3',
  Columns2: 'lucide:columns-2',
  Columns3: 'lucide:columns-3',
  Columns4: 'lucide:columns-4',
  Plus: 'lucide:plus',
  Grip: 'lucide:grip-vertical',
  Copy: 'lucide:copy',
  Clipboard: 'lucide:clipboard',
  MenuDown: 'icon-park-solid:down-one',
  SizeS: 'mdi:size-s',
  SizeM: 'mdi:size-m',
  SizeL: 'mdi:size-l',
  AspectRatio: 'mdi:aspect-ratio',
  Gaode: 'echo-gaode',
  Baidu: 'echo-baidu',
  Youku: 'echo-youku',
  BiliBili: 'echo-bilibili',
  Modao: 'echo-modao',
  Lanhu: 'echo-lanhu',
  QQVideo: 'echo-qqvideo',
  Figma: 'echo-figma',
  Canva: 'echo-canva',
  Processon: 'echo-processon',
  Codepen: 'echo-codepen',
  Jinshuju: 'echo-jinshuju',
  PanelLeft: 'lucide:panel-left',
  PanelRight: 'lucide:panel-right',
  Columns: 'lucide:columns',
  AI: 'meteocons:star-fill',
  ChevronRight: 'lucide:chevron-right',
  Paste: 'lucide:clipboard-paste',
  Cut: 'lucide:scissors',
  File: 'lucide:file',
  Refresh: 'lucide:refresh-ccw',
  Eye: 'lucide:eye',
  Printer: 'lucide:printer',
  Tablet: 'lucide:tablet',
  Phone: 'lucide:smartphone',
  Monitor: 'lucide:monitor',
  TextSelect: 'lucide:text-select',
  SpellCheck: 'lucide:spell-check-2',
  DocSearch: 'fluent:document-search-24-regular',
  Close: 'lucide:x',
  ImageSize: 'fluent:resize-image-24-filled',
  FlipVertical: 'lucide:flip-vertical',
  FlipHorizontal: 'lucide:flip-horizontal',
}

export default icons
